import { IDEState, OutputMessage } from '@/types';
import { createContext } from 'react';

export type NavigationHistoryMode = 'push' | 'none';

export interface IDEContextType {
    state: IDEState;
    openFile: (fileId: string, projectId: string) => void;
    selectFile: (fileId: string, projectId: string) => void;
    selectProject: (projectId: string) => void;
    closeTab: (tabId: string) => void;
    closeAllTabs: () => void;
    closeOtherTabs: (tabId: string) => void;
    setActiveTab: (tabId: string) => void;
    toggleProjectExpansion: (projectId: string) => void;
    toggleFileExplorer: () => void;
    toggleOutputPanel: () => void;
    setOutputPanelTab: (tabName: string) => void;
    addOutputMessage: (message: string, type: OutputMessage['type']) => void;
    markOutputInitialized: () => void;
    updateState: (updates: Partial<IDEState>) => void;
    navigateToFile: (projectName: string, fileName: string, history?: NavigationHistoryMode) => void;
    navigateToProject: (projectName: string, history?: NavigationHistoryMode) => void;
    expandProject: (projectId: string) => void;
    setModalOpen: (isOpen: boolean) => void;
    toggleSearch: () => void;
    openSearch: () => void;
    closeSearch: () => void;
}

export const IDEContext = createContext<IDEContextType | undefined>(undefined);
